module.exports = __webpack_public_path__ + "img/f-1.4a680dd-en.0890eb74.png";